import { axiosService } from "./axiosService";

const revenueApi = {
    getByMonth(params) {
        const url = `/revenue`;
        return axiosService.get(url, { params })
    },
    createRevenue(body) {
        const url = '/revenue';
        return axiosService.post(url, body)
    },
    updateBudget(body) {
        const url = '/budget';
        return axiosService.post(url, body)
    },
    getGrowth(body) {
        const url = `/growth`;
        return axiosService.post(url, body)
    },
}

export default revenueApi;